<template>
  <div>
    <div class="relation" v-if="pcis">
      <div class="bannder">
        <img src="@/assets/gongsijies.png" alt />
      </div>
      <div class="container container2">
        <div class="item-one">
            <div class="item-one-text">
              <p>深圳汇客科技</p>
              <!-- <div style="text-indent:2em;font-size:14px;"> -->
              <div>
                深圳汇客科技有限公司，是一家专注企业私域流量解决方案的SAAS软件技术服务商， 秉持“助力<br />
                企业深耕私域流量，为企业赋能，让企业精准连接客户”的使命，坚持技术驱动创新，团队目前围<br />
                绕微信生态，全力打造的拳头产品“蓝小助SCRM系统”，为工厂/劳务派遣企业提供完整的线上普工<br />
                招聘智慧解决方案，实现企业拥有属于自己的普工私域流量池，为用工需求和普工之间搭建高效的<br />
                直达互动桥梁，有效解决普工人力资源行业招工难，成本高，以及效率低导致没法短时间内大批量<br />
                招工问题，大幅降低了企业对网上第三方平台及传统线下招聘方式的过度依赖，最高可节约80%左<br />
                右的招工成本，成为工厂/劳务派遣企业转型线上普工招聘的利器。
              </div>
            </div>
            <div class="item-one-img">
              <img src="@/assets/introduce-one.png" alt />
            </div>
        </div>
      </div>
      <div class="container2-box">
        <div class="container2">
          <div class="item-two">
              <div class="item-two-img">
                <img src="@/assets/introduce-two.png" alt />
              </div>
              <div class="item-two-text">
                <p>蓝小助SCRM系统</p>
                <!-- <div style="text-indent:2em;font-size:14px;"> -->
                <div>
                  蓝小助SCRM系统，专注普工招聘，让大批量普工招聘变简单，团队经过2年的全力打磨，经历了调<br />
                  研，设计、开发，推翻重来，再调研，再设计、再开发，迭代的曲折历程，蓝小助SCRM系统可帮助<br />
                  工厂/劳务派遣企业招工快速进入智能招聘时代，为企业搭建属于企业自己的线上招聘平台，建立<br />
                  和沉淀可复用的普工人力资源私域流量池，颠覆传统的通过电话/个人微信/发朋友圈等低效沟通方<br />
                  式，让招聘需求可直接实时触达普工，推荐工作，报名确认，面试确认，整个普工招聘闭环，线上<br />
                  流程全智能化，大幅提升招工效率，同时也让海量普工招聘渠道资源管理变成现实，成功解决短时<br />
                  间大批量普工招聘的获客难问题，为企业实现长期低成本线上高质量招工。
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="move-introduce" v-else>
      <div class="module-move-title">
        <div>
          <p class="text">
            深圳汇客科技有限公司
          </p>
          <p class="word">SHEN ZHEN HUI KE KE JI</p>
        </div>
      </div>
      <div class="module-move-content-one">
        <div class="item-one-text">
          <p class="title">深圳汇客科技</p>
          <p class="content-text">
              深圳汇客科技有限公司，是一家专注企业私域流量解决方案的SAAS软件技术服务商， 秉持“助力
              企业深耕私域流量，为企业赋能，让企业精准连接客户”的使命，坚持技术驱动创新，团队目前围
              绕微信生态，全力打造的拳头产品“蓝小助SCRM系统”，为工厂/劳务派遣企业提供完整的线上普工
              招聘智慧解决方案，实现企业拥有属于自己的普工私域流量池，为用工需求和普工之间搭建高效的
              直达互动桥梁，有效解决普工人力资源行业招工难，成本高，以及效率低导致没法短时间内大批量
              招工问题，大幅降低了企业对网上第三方平台及传统线下招聘方式的过度依赖，最高可节约80%左
              右的招工成本，成为工厂/劳务派遣企业转型线上普工招聘的利器。
          </p>
        </div>
        <div class="item-img">
          <img src="@/assets/introduce-one.png" alt />
        </div>
      </div>
      <div class="module-move-content-two">
        <div class="item-one-text">
          <p class="title">蓝小助SCRM系统</p>
          <p class="content-text">
            蓝小助SCRM系统，专注普工招聘，让大批量普工招聘变简单，团队经过2年的全力打磨，经历了调
            研，设计、开发，推翻重来，再调研，再设计、再开发，迭代的曲折历程，蓝小助SCRM系统可帮助
            工厂/劳务派遣企业招工快速进入智能招聘时代，为企业搭建属于企业自己的线上招聘平台，建立
            和沉淀可复用的普工人力资源私域流量池，颠覆传统的通过电话/个人微信/发朋友圈等低效沟通方
            式，让招聘需求可直接实时触达普工，推荐工作，报名确认，面试确认，整个普工招聘闭环，线上
            流程全智能化，大幅提升招工效率，同时也让海量普工招聘渠道资源管理变成现实，成功解决短时
            间大批量普工招聘的获客难问题，为企业实现长期低成本线上高质量招工。
          </p>
        </div>
        <div class="item-img">
          <img src="@/assets/introduce-two.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      pcis: this.$store.state.pcIs, // 根据窗口大小变化来判断移动端PC端
    }
  }
};
</script>
<style lang="less" scoped>
.relation {
  z-index: 2;
  .bannder {
    width: 100%;
    img {
      width: 100%;
      margin: 0 auto;
    }
  }
  .container2-box {
    background: #F8FAFC;
  }
  .container2 {
      width: 1200px;
      padding: 0 15px;
      margin: auto;
  }
  .item-one, .item-two {
    display: flex;
    justify-content: space-between;
    .item-one-text {
      >p {
        padding-top: 120px;
      }
    }
    .item-one-text, .item-two-text {
      >p {
        margin-bottom: 22px;
        font-size: 26px;
        font-size: 700;
        color: #666666;
        line-height: 51px;
      }
      >div {
        font-size: 14px;
        color: #666666;
      }
    }
    .item-one-img {
      padding-top: 130px;
      height: 224px;
      >img {
        width: 369px;
        height: 224px;
      }
    }
  }
  .item-two {
    margin: 50px 0 0;
    padding: 50px 0 106px;
    .item-two-img {
      padding-top: 9px;
      >img {
        width: 369px;
        height: 224px;
      }
    }
  }
}
</style>
<style lang="less" scoped>
// 移动端
.move-introduce {
  p {
    margin: 0;
  }
  .module-move-title {
    width: 100%;
    background: url('~@/assets/introduce-banner-bg.png');
    background-size: 100% 100%;
    height: 501px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    .text {
      font-size: 83px;
      font-weight: 800;
      color: #FFFFFF;
      line-height:115px;
    }
    .word {
      font-size: 26px;
      color: #FFFFFF;
      line-height: 35px;
    }
  }
  .module-move-content-one, .module-move-content-two {
    padding: 46px 51px 128px;
    .item-one-text {
      font-size: 48px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 67px;
      .title {
        padding: 88px 0 64px;
        font-weight: bold;
      }
      .content-text {
        font-size: 35px;
        font-weight: normal;
        color: #999999;
        line-height: 48px;
      }
    }
    .item-img {
      margin-top: 64px;
      >img {
        width: 100%;
        height: 669px;
      }
    }
  }
  .module-move-content-two {
    padding: 0 51px 128px;
    background: #F8FAFCFF;
  }
}
</style>

